import { atom } from 'jotai';

export const navigationOpen = atom<boolean>(false);
export const navigationOpenPro = atom<boolean>(false);

export const openNavigationToggle = atom(null, (get, set, by) =>
  set(navigationOpen, (value) => !value)
);

export const openNavigationProToggle = atom(null, (get, set, by) =>
  set(navigationOpen, (value) => !value)
);
